/**
 * CAUTION:
 * DO NOT CHANGE ANY NAME
 * IT'S BASED ON DATABASE VALUES
 */
const qrMenuItems = [
    {
        id: '/',
        name: 'root',
        icon: 'bx bx-home',
        title: 'Home',
        isRoot: true,
        isActive: true,
    },
    {
        id: 'ticketmaster',
        name: 'ticketmaster',
        image: 'oss.png',
        title: 'TicketMaster',
        isRoot: true,
        child: [
            {
                id: '/ticketmaster/am-app',
                name: 'oss-app',
                icon: 'bx bx-list-plus',
                title: 'AM APP',
                permission: 'ticketmaster-refresh',
                isActive: true,
            },
            {
                id: '/ticketmaster/am-web',
                name: 'oss-web',
                icon: 'bx bx-list-plus',
                title: 'AM WEB',
                permission: 'ticketmaster-refresh', // Required permission for this sub menu
                isActive: false,
            },
            {
                id: '/ticketmaster/oss-web-invoices',
                name: 'oss-web-invoices',
                icon: 'bx bx-receipt',
                title: 'Pull AM Invoices',
                permission: 'ticketmaster-refresh',
                isActive: false,
            },
            {
                id: '/ticketmaster/oss-credits',
                name: 'oss-credits',
                icon: 'bx bx-receipt',
                title: "AM Credits in Account",
                permission: 'ticketmaster-refresh',
                isActive: false,
            },
            // ---
            // {
            //     id: '/ticketmaster/oss-pass-reset',
            //     name: 'oss-pass-reset',
            //     icon: 'bx bx-reset',
            //     title: 'OSS Reset Password',
            // },
            // ---
            {
                id: '/ticketmaster/spreadsheet-to-qr',
                name: 'spreadsheet-to-qr',
                icon: 'bx bx-qr',
                title: 'Spreadsheet upload to QR',
                permission: 'ticketmaster-generate',
                isActive: true,
            },
            {
                id: '/ticketmaster/pkpass-upload',
                name: 'pkpass-upload',
                icon: 'bx bx-barcode',
                title: 'iPhone PKPass to PDF-QR',
                permission: 'ticketmaster-generate',
                isActive: false,
            },
            {
                id: '/ticketmaster/pkpass-link',
                name: 'pkpass-link',
                icon: 'bx bx-mobile',
                title: 'Wallet Links to QR',
                permission: 'ticketmaster-generate',
                isActive: false,
            },
        ],
    },
    {
        id: 'paciolan',
        name: 'paciolan',
        image: 'paciolan.png',
        title: 'Paciolan',
        isRoot: true,
        child: [
            {
                id: '/paciolan/scrape-to-barcode',
                name: 'scrape-to-barcode',
                icon: 'bx bx-barcode',
                title: 'Scrape Paciolan to Barcode',
                // permission: 'paciolan-refresh', // TODO: Uncomment when permission is ready
                isActive: true,
            },
        ],
    },
    {
        id: 'seatgeek',
        name: 'seatgeek',
        image: 'seatgeek.png',
        title: 'SeatGeek',
        isRoot: true,
        child: [
            {
                id: '/seatgeek/sg-spreadsheet-to-qr',
                name: 'sg-spreadsheet-to-qr',
                icon: 'bx bx-qr',
                title: 'SG Spreadsheet to QR',
                permission: 'seatgeek-generate',
                isActive: true,
            },
            {
                id: '/seatgeek/seatgeek-api',
                name: 'seatgeek-api',
                icon: 'bx bx-list-ol',
                title: 'SeatGeek Official API to QR',
                permission: 'seatgeek-refresh',
                isActive: true,
            },
            {
                id: '/seatgeek/seatgeek-scrape',
                name: 'seatgeek-scrape',
                icon: 'bx bx-barcode',
                title: 'SeatGeek to QR v2',
                permission: 'seatgeek-refresh',
                isActive: true,
            },
        ],
    },
    {
        id: 'ballpark',
        name: 'ballpark',
        image: 'ballpark.png',
        title: 'BallPark',
        isRoot: true,
        child: [
            {
                id: '/ballpark/mlb-app-to-qr',
                name: 'mlb-app-to-qr',
                icon: 'bx bx-list-ol',
                title: 'BallPark to QR',
                permission: 'ballpark-refresh',
                isActive: false,
            },
            {
                id: '/ballpark/mlb-web-to-qr',
                name: 'mlb-web-to-qr',
                icon: 'bx bx-list-ol',
                title: 'MLB WEB',
                permission: 'ballpark-refresh',
                isActive: false,
            },
            {
                id: '/ballpark/mlb-app-verify',
                name: 'mlb-app-verify',
                icon: 'bx bx-link',
                title: 'Ballpark Verify Email',
                permission: 'ballpark-refresh',
                isActive: false,
            },
            {
                id: '/ballpark/mlb-create-account',
                name: 'mlb-create-account',
                icon: 'bx bx-plus',
                title: 'MLB Create Account',
                permission: 'ballpark-refresh',
                isActive: false,
            },
        ],
    },
]

export default qrMenuItems
